import { AssetActivityControlRequest, AuthModel } from "@gtpl/shared-models/common-models";
import { Body, Controller, Inject, Logger, Post } from "@nestjs/common";
import { AssentManagementJobService } from "./asset-mgmt.service";
import { Request } from 'express';
import { REQUEST } from '@nestjs/core';
import { ApiBearerAuth } from "@nestjs/swagger";

@ApiBearerAuth()
@Controller('assent-mgnt-jobs')
export class AssetManagementController {
    constructor(
        private service: AssentManagementJobService,
    ) {
    }

    @Post('/triggerJobForAssetActivity')
    async triggerJobForAssetActivity(@Body() reqObj: AssetActivityControlRequest) {
        return await this.service.triggerJobForAssetActivity(reqObj);
    }

    @Post('/controlSmartPlug')
    async controlSmartPlug() {
        return await this.service.controlSmartPlug();
    }

    @Post('/getCronPatternFor24Format')
    async getCronPatternFor24Format() {
        return this.service.getCronPatternFor24Format('2022-08-10', 12, 21);
    }
}